<template>
  <div class="home">
    <!-- 头部导航 -->
    <header class="header">
      <div class="header-content">
        <div class="logo">
          <img src="@/assets/logo.png" alt="ihongen" />
          <span class="logo-text">洪恩智能编程</span>
        </div>
        <div class="header-right">
          &nbsp;
        </div>
      </div>
    </header>

    <!-- 主横幅区域 -->
    <section class="hero-banner">
      <div class="banner-content">
        <h1 class="hero-title">洪恩智能编程</h1>
        <p class="hero-subtitle">爱学所以学得好，零基础编程选洪恩</p>
        <div class="hero-buttons">
          <button class="btn btn-disabled" @click=";" disabled>立即体验</button>
        </div>
      </div>
      <div class="banner-image">
        <div class="placeholder-image">
          <img src="@/assets/xct.jpg" alt="洪恩智能编程" />
        </div>
      </div>
    </section>

    <!-- 学习优势 -->
    <section class="advantages-section">
      <div class="section-header">
        <h2 class="section-title">为什么选择我们</h2>
        <p class="section-subtitle">科学的教学方法，专业的师资团队</p>
      </div>
      <div class="advantages-grid">
        <div class="advantage-item" v-for="advantage in advantages" :key="advantage.id">
          <div class="advantage-icon">
            <img :src="advantage.icon" :alt="advantage.title" class="icon-img" />
          </div>
          <h3 class="advantage-title">{{ advantage.title }}</h3>
          <p class="advantage-desc">{{ advantage.desc }}</p>
        </div>
      </div>
    </section>

    <!-- 培训人员信息公示 -->
    <section class="teachers-section">
      <div class="section-header">
        <h2 class="section-title">培训人员信息公示</h2>
        <p class="section-subtitle">专业的师资团队，持证上岗</p>
      </div>
      <div class="teachers-grid">
        <div class="teacher-card" v-for="teacher in teachers" :key="teacher.id">
          <div class="teacher-photo">
            <div class="photo-placeholder" :style="{ backgroundColor: teacher.photoColor }">
              <img :src="teacher.avatar" :alt="teacher.name" class="avatar-img" />
            </div>
          </div>
          <div class="teacher-info">
            <h3 class="teacher-name">{{ teacher.name }}</h3>
            <p class="teacher-cert">教师资格证号：{{ teacher.certNo }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部信息 -->
    <footer class="footer">
      <div class="footer-content">
        <div class="footer-links">
          <a href="/zhizhao.jpg" target="_blank" class="footer-link">营业执照</a>
          <a href="/zhangcheng.html" target="_blank" class="footer-link">机构章程</a>
          <a href="/sf.html" target="_blank" class="footer-link">收费标准</a>
          <a href="/stf.html" target="_blank" class="footer-link">收退费规则</a>
          <a href="/hegui2.html" target="_blank" class="footer-link">从业人员合规承诺书</a>
          <a href="/zs.html" target="_blank" class="footer-link">招生简章</a>
          <a href="/template.html" target="_blank" class="footer-link">培训合同示范模板</a>
          <a href="/hegui1.html" target="_blank" class="footer-link">培训材料合规承诺书</a>
          <a href="/privacy1.html" target="_blank" class="footer-link">儿童隐私保护声明</a>
          <a href="/privacy2.html" target="_blank" class="footer-link">平台隐私政策</a>
          <router-link :to="{ name: 'contact' }" class="footer-link">联系我们</router-link>
        </div>
        <div class="footer-info">
          <p>Copyright ©2026 广东洪恩文化创意科技有限公司</p>
          <p>
            <a href="https://beian.miit.gov.cn" class="footer-link" target="_blank">粤ICP备2025458115号-1</a>
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import {
  isLoggedIn, getUser, isAdmin, logout,
} from '@/utils/auth';
import f1Icon from '@/assets/f1.png';
import f2Icon from '@/assets/f2.png';
import f3Icon from '@/assets/f3.png';
import f4Icon from '@/assets/f4.png';
import cxPhoto from '@/assets/cx.png';
import fljPhoto from '@/assets/flj.png';
import ysyPhoto from '@/assets/ysy.png';
import zhqPhoto from '@/assets/zhq.png';
import zhPhoto from '@/assets/zh.png';
import zyxPhoto from '@/assets/zyx.png';

export default {
  name: 'HomeView',
  computed: {
    loggedIn() {
      return isLoggedIn();
    },
    currentUser() {
      return getUser() || {};
    },
    admin() {
      return isAdmin();
    },
  },
  methods: {
    handleUserCommand(command) {
      if (command === 'logout') {
        logout();
        window.location.reload();
      } else if (command === 'admin') {
        this.$router.push('/admin');
      } else {
        this.$router.push(`/${command}`);
      }
    },
  },
  data() {
    return {
      advantages: [
        {
          id: 1,
          icon: f1Icon,
          title: '原创动画 激发兴趣',
          desc: '动画融入知识内容，探索奇妙编程世界',
          color: '#5B4FFF',
        },
        {
          id: 2,
          icon: f2Icon,
          title: '互动学习 动脑动手',
          desc: '软硬件结合激发学习自驱力',
          color: '#FFB84D',
        },
        {
          id: 3,
          icon: f3Icon,
          title: '快速入门 循序渐进',
          desc: '零基础轻松入门 每一步都有成就感',
          color: '#36CFC9',
        },
        {
          id: 4,
          icon: f4Icon,
          title: '规划-学习-指导',
          desc: '零基础学编程 从这里开始',
          color: '#FF6B9D',
        },
      ],
      teachers: [
        {
          id: 1,
          name: '樊丽佳',
          certNo: '20165300332002408',
          avatar: fljPhoto,
          photoColor: '#E6F7FF',
        },
        {
          id: 2,
          name: '张慧青',
          certNo: '20103714842006977',
          avatar: zhqPhoto,
          photoColor: '#FFF1F0',
        },
        {
          id: 3,
          name: '赵云雪',
          certNo: '20173714842000458',
          avatar: zyxPhoto,
          photoColor: '#FFFBE6',
        },
        {
          id: 4,
          name: '尹士炎',
          certNo: '20234100171012051',
          avatar: ysyPhoto,
          photoColor: '#F6FFED',
        },
        {
          id: 5,
          name: '钟浩',
          certNo: '20243520041001444',
          avatar: zhPhoto,
          photoColor: '#FEFFE6',
        },
        {
          id: 6,
          name: '程希',
          certNo: '20211100141005022',
          avatar: cxPhoto,
          photoColor: '#FFF0F6',
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.home {
  min-height: 100vh;
  background-color: #ffffff;
}

/* 头部导航 */
.header {
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;

  img {
    height: 40px;
    width: 40px;
  }

  .logo-text {
    font-size: 20px;
    font-weight: 600;
    color: #1a1a1a;
  }
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-link {
  text-decoration: none;
  color: #666;
  font-size: 14px;
  padding: 6px 16px;
  border-radius: 4px;
  transition: all 0.3s;

  &:hover {
    color: #5B4FFF;
  }

  &-primary {
    background-color: #5B4FFF;
    color: #fff;

    &:hover {
      background-color: #4840CC;
      color: #fff;
    }
  }
}

.user-dropdown {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #333;
  font-size: 14px;
}

.user-name {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nav {
  display: flex;
  gap: 32px;

  .nav-item {
    text-decoration: none;
    color: #666;
    font-size: 16px;
    transition: color 0.3s;

    &:hover {
      color: #5B4FFF;
    }

    &.active {
      color: #5B4FFF;
      font-weight: 600;
    }

    &.download-btn {
      background: linear-gradient(135deg, #5B4FFF 0%, #8B7FFF 100%);
      color: white;
      padding: 8px 20px;
      border-radius: 20px;

      &:hover {
        color: white;
        opacity: 0.9;
      }
    }
  }
}

/* 主横幅 */
.hero-banner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.banner-content {
  .hero-title {
    font-size: 48px;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1.3;
    margin-bottom: 20px;
  }

  .hero-subtitle {
    font-size: 20px;
    color: #666;
    margin-bottom: 40px;
  }
}

.hero-buttons {
  display: flex;
  gap: 16px;

  .btn {
    padding: 14px 32px;
    font-size: 16px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s;
    font-weight: 500;

    &.btn-primary {
      background: linear-gradient(135deg, #5B4FFF 0%, #8B7FFF 100%);
      color: white;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(91, 79, 255, 0.3);
      }
    }

    &.btn-secondary {
      background: white;
      color: #5B4FFF;
      border: 2px solid #5B4FFF;

      &:hover {
        background: #f5f4ff;
      }
    }
  }
}

.banner-image {
  .placeholder-image {
    width: 546px;
    height: 327px;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);

    img {
      width: 100%;
      height: auto;
    }
  }
}

/* 通用section样式 */
.section-header {
  text-align: center;
  margin-bottom: 60px;

  .section-title {
    font-size: 36px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 16px;
  }

  .section-subtitle {
    font-size: 18px;
    color: #666;
  }
}

/* 优势区域 */
.advantages-section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 24px;
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
}

.advantage-item {
  text-align: center;

  .advantage-icon {
    margin-bottom: 20px;

    .icon-img {
      width: 80px;
      height: 80px;
      object-fit: contain;
      margin: 0 auto;
      display: block;
    }
  }

  .advantage-title {
    font-size: 20px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 12px;
  }

  .advantage-desc {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
  }
}

/* 培训人员信息公示 */
.teachers-section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 24px;
  background: #ffffff;
}

.teachers-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;
}

.teacher-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  text-align: center;
  transition: all 0.3s;
  cursor: pointer;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }

  .teacher-photo {
    margin-bottom: 16px;

    .photo-placeholder {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 48px;
      margin: 0 auto;
      border: 3px solid #f0f0f0;
    }

    .avatar-img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
    }
  }

  .teacher-info {
    .teacher-name {
      font-size: 18px;
      font-weight: 600;
      color: #1a1a1a;
      margin-bottom: 8px;
    }

    .teacher-cert {
      font-size: 13px;
      color: #999;
      line-height: 1.5;
      word-break: break-all;
    }
  }
}

/* 底部 */
.footer {
  background: #1a1a1a;
  color: #999;
  padding: 40px 24px 24px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 24px;
  justify-content: center;

  .footer-link {
    color: #999;
    text-decoration: none;
    font-size: 14px;

    &:hover {
      color: #fff;
    }
  }
}

.footer-info {
  text-align: center;
  padding-top: 24px;
  border-top: 1px solid #333;

  p {
    margin: 8px 0;
    font-size: 14px;
  }

  .footer-link {
    color: #999;
    text-decoration: none;
    margin: 0 12px;

    &:hover {
      color: #fff;
    }
  }
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .courses-grid,
  .advantages-grid,
  .works-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .teachers-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .hero-banner {
    grid-template-columns: 1fr;
    gap: 40px;
  }
}

@media (max-width: 768px) {
  .nav {
    display: none;
  }

  .hero-banner {
    padding: 40px 24px;
    gap: 24px;
  }

  .banner-content {
    .hero-title {
      font-size: 28px !important;
      margin-bottom: 16px;
    }

    .hero-subtitle {
      font-size: 16px !important;
      margin-bottom: 24px;
    }
  }

  .banner-image {
    .placeholder-image {
      width: 100%;
      height: auto;
      max-height: 300px;

      img {
        width: 100%;
        height: auto;
      }
    }
  }

  .hero-buttons {
    flex-direction: column;

    .btn {
      width: 100%;
    }
  }

  .courses-grid,
  .advantages-grid,
  .works-grid,
  .teachers-grid {
    grid-template-columns: 1fr;
  }

  .section-title {
    font-size: 28px !important;
  }
}
</style>
